export default {
  type: 'subscript',
  tagName: 'sub'
}
